<script setup>
import Editor from "../components/common/Editor.vue";
import { ref } from 'vue'

const props = defineProps({
  context: Object,
})

const field = ref(props.context.value || 'a')

function handleInput(newValue) {
  field.value = newValue;
  props.context.node.input(newValue);
}

</script>

<template>
  
  <Editor :readOnly="false" :value="field" />
</template>

